import React, { Component } from "react";
import EditableDataContainer from "../containers/EditableDataContainer";
import PURCHASEIRQCreditScoreView from "../views/IrqCreditScoreView";
import ApiConfig from "../config/ApiConfig";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import { number, object } from "yup";
import { validationMap } from "../validations/validationMap";
import StatusCheck from "../components/StatusCheck";

class PurchaseIrqCreditScorePage extends Component {
  render() {
    const submitEndpoint =
      ApiConfig.protocol + ApiConfig.apiUri + ApiConfig.irqEndpoint;

    return (
      <div className="page-wrapper">
        <StatusCheck />
        <EditableDataContainer
          id="purchaseIrq"
          submitEndpoint={submitEndpoint}
          mutateRedux="always"
          isCreate
          isStep
          validationSchema={validationMap.PurchaseIrqCreditScorePage}
        >
          <PURCHASEIRQCreditScoreView
            content={contentMap.PurchaseIrqCreditScorePage}
            navigationsAway={customNavigationMap.PurchaseIrqCreditScorePage}
          />
        </EditableDataContainer>
      </div>
    );
  }
}

export default withRouterUtilities(PurchaseIrqCreditScorePage);
